import { useEffect, useState } from 'react'

import PublicationModal from './PublicationModal'
import useFetchPublication from './useFetchPublication'
import { getUrlParameter, removeUrlParameter, setUrlParameter } from './utils'
import InterimModal from './InterimModal'

import { useTranslation } from 'react-i18next'

function PublicationLoader({ publicationId }: { publicationId: string }) {
  const [show, setShow] = useState(false)
  const { data, error, loading } = useFetchPublication(publicationId, show)
  const { t } = useTranslation()

  useEffect(() => {
    if (!show && getUrlParameter('pub') == 'show') {
      openModal()
    }
  }, [])

  const openModal = () => {
    setShow(true)
    setUrlParameter('pub', 'show')
    window.scrollTo(0, 0)
  }

  const closeModal = () => {
    setShow(false)
    removeUrlParameter('pub')
    window.scrollTo(0, 0)
  }

  if (!show) {
    return (
      <button onClick={openModal} className="showpub blueBtn rounded">
        {t('open-publication')}
      </button>
    )
  }

  if (loading) {
    return <InterimModal type="loading" onClick={closeModal} />
  }
  if (error) {
    return <InterimModal type="error" onClick={closeModal} />
  }
  if (data) {
    return <PublicationModal onCloseModal={closeModal} {...data} />
  }

  return null
}

export default PublicationLoader
